import { map } from 'lodash'
import { Fragment } from 'react'
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
  useFieldArray,
} from 'react-hook-form'

import { Checkbox, Label } from '@/components/ui'
import FormGroup from '../../../../core/components/FormGroup'
import { IFormValues } from './ViewUserPage'

export interface EditUserCustomPermissionsProps {
  index: number
  control: Control<IFormValues>
  register: UseFormRegister<IFormValues>
  errors: FieldErrors<IFormValues>
  disabled: boolean
  setValue: UseFormSetValue<IFormValues>
  watch: UseFormWatch<IFormValues>
}

export const EditUserCustomPermissions = (
  props: EditUserCustomPermissionsProps,
): JSX.Element => {
  const { index, control, register, errors, disabled, setValue, watch } = props

  const { fields } = useFieldArray({
    control,
    name: `customPermissions.${index}.permissions`,
  })

  return (
    <Fragment key={index}>
      {fields.length > 0 && (
        <div className="flex flex-col items-start gap-3 p-3 w-full rounded-md border border-monochrome-120">
          {map(fields, (field, ind) => {
            return (
              <div
                className="flex flex-col items-start gap-2 w-full"
                key={field.id}
              >
                {fields.length !== 1 && (
                  <Label className="text-body-medium text-monochrome-1">
                    {field.name}
                  </Label>
                )}
                <div className="flex items-start gap-3 w-full">
                  <FormGroup
                    label="View"
                    direction="row"
                    labelClassName="whitespace-nowrap"
                  >
                    <Checkbox
                      checked={watch(
                        `customPermissions.${index}.permissions.${ind}.view`,
                      )}
                      onCheckedChange={(checked) => {
                        setValue(
                          `customPermissions.${index}.permissions.${ind}.view`,
                          Boolean(checked as boolean),
                        )
                        if (
                          watch(
                            `customPermissions.${index}.permissions.${ind}.edit`,
                          )
                        ) {
                          setValue(
                            `customPermissions.${index}.permissions.${ind}.edit`,
                            Boolean(checked as boolean),
                          )
                        }
                      }}
                      disabled={disabled}
                    />
                  </FormGroup>
                  <FormGroup
                    label="Edit"
                    direction="row"
                    labelClassName="whitespace-nowrap"
                  >
                    <Checkbox
                      checked={watch(
                        `customPermissions.${index}.permissions.${ind}.edit`,
                      )}
                      onCheckedChange={(checked) => {
                        setValue(
                          `customPermissions.${index}.permissions.${ind}.edit`,
                          Boolean(checked as boolean),
                        )
                      }}
                      disabled={
                        disabled ||
                        !watch(
                          `customPermissions.${index}.permissions.${ind}.view`,
                        )
                      }
                    />
                  </FormGroup>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </Fragment>
  )
}
